<template>
  <div class="r-container">
    <div class="left-bar">
      <Sticky>
        <el-scrollbar wrap-class="scrollbar-wrapper">
          <el-menu index="1" :default-openeds="['2']">
            <el-menu-item
              @click="
                handleScrollToParagraph('9d827268-7f76-4165-a6ad-90b28c0b393b')
              "
              index="i-1"
            >
              <i class="icon-mini-block"></i>封面
            </el-menu-item>
            <el-menu-item
              @click="
                handleScrollToParagraph('b387fea9-d948-4bad-9b57-5c110830718a')
              "
              index="i-2"
            >
              <i class="icon-mini-block"></i>标题
            </el-menu-item>
            <el-menu-item
              @click="
                handleScrollToParagraph('89ca78e9-730a-4616-8554-444b1a784574')
              "
              index="i-3"
            >
              <i class="icon-mini-block"></i>案例信息
            </el-menu-item>
            <el-menu-item
              @click="
                handleScrollToParagraph('992630fd-9ba7-46de-b058-97523a6961b1')
              "
              index="i-4"
            >
              <i class="icon-mini-block"></i>案例亮点
            </el-menu-item>
            <el-menu-item
              @click="
                handleScrollToParagraph('9fc0380d-ce3e-45d0-81be-4738dfaf64c8')
              "
            >
              <i class="icon-mini-block"></i>案例设计理念
            </el-menu-item>
            <el-submenu index="2" ref="subMenu">
              <template slot="title"
                ><i class="icon-mini-block"></i>空间展示</template
              >
              <LeftParagraphs :paragraphs="detail.paragraphs"></LeftParagraphs>
            </el-submenu>
            <el-menu-item
              @click="
                handleScrollToParagraph('c34a3444-d4be-4514-87cb-9adfd87eb1da')
              "
              index="i-5"
            >
              <i class="icon-mini-block"></i>结语
            </el-menu-item>
          </el-menu>
          <div style="height: 80px"></div>
        </el-scrollbar>
      </Sticky>
    </div>
    <div class="right-container">
      <BasePro v-if="!loading" :detail="detail"></BasePro>
      <FormTitle
        class="mt28"
        title="案例设计理念"
        id="9fc0380d-ce3e-45d0-81be-4738dfaf64c8"
      ></FormTitle>
      <el-input
        v-if="!loading"
        type="textarea"
        :rows="5"
        :maxlength="1000"
        placeholder="提供200-300字案例设计灵感、功能设计思路、产品搭配、色彩搭配等文字性描述"
        v-model="detail.designConcept"
      >
      </el-input>
      <FormTitle
        class="mt28"
        title="空间展示"
        subTitle="（无内容的默认空间最终将不展示，无需删除！）"
      ></FormTitle>
      <EditParagraphs
        v-if="!loading"
        :paragraphs="detail.paragraphs"
      ></EditParagraphs>
      <FormTitle
        class="mt28"
        title="结语"
        id="c34a3444-d4be-4514-87cb-9adfd87eb1da"
      ></FormTitle>
      <el-input
        v-if="!loading"
        type="textarea"
        :rows="5"
        :maxlength="1000"
        placeholder="针对此案例的总结性文字，提供更多功能性信息、生活方式等给用户"
        v-model="detail.conclusion"
      >
      </el-input>
      <div class="flex-right" v-if="hasWxa">
        <el-select class="publish-target" v-model="detail.publishTarget">
          <el-option label="同时发布到APP和小程序" :value="1"></el-option>
          <el-option label="仅发布到app" :value="2"></el-option>
          <el-option label="仅发布到小程序" :value="3"></el-option>
        </el-select>
      </div>
      <FixedFooter :detail="detail">
        <el-button type="primary" plain @click="handlePreview">预览</el-button>
        <el-button type="primary" plain @click="handleSaveToDraft(false)"
          >保存到草稿箱</el-button
        >
        <el-button type="primary" @click="handlePublished">发布</el-button>
      </FixedFooter>
    </div>
    <!--添加空间-->
    <el-dialog
      title="添加空间"
      :close-on-click-modal="false"
      :visible.sync="isShowDialog"
      width="460px"
    >
      <el-input
        placeholder="请输入空间名称，最多5个字哦～"
        maxlength="5"
        v-model="newParagraphName"
        show-word-limit
      ></el-input>
      <div class="dialog-footer" slot="footer">
        <el-button @click="handleHideAddDialog">取消</el-button>
        <el-button type="primary" @click="handleAddParagraphs">确认</el-button>
      </div>
    </el-dialog>
    <!-- 预览 -->
    <MobileBox
      :title="detail.title"
      append-to-body
      v-if="showPreview"
      :visible.sync="showPreview"
    >
      <Preview
        :caseData="detail"
        :user="{ name: name, avatar: avatar }"
      ></Preview>
    </MobileBox>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Sticky from "@/components/Sticky";
import LeftParagraphs from "@/components/LeftParagraphs";
import EditParagraphs from "@/components/EditParagraphs";
import BasePro from "@/components/BasePro";
import FormTitle from "@/components/FormTitle";
import Preview from "@/components/Preview";
import FixedFooter from "@/components/FixedFooter";
import MobileBox from "@/components/MobileBox";
import {
  fetchHouseDraftData,
  fetchHouseEditData,
  fetchPublish,
  fetchSaveDraft,
} from "@/api";
import { guid } from "@/utils";
import { roomDefault } from "@/const/defautDraft";
let timer;
let isInitial = true;
let datenow;
export default {
  provide() {
    return {
      editControl: this,
    };
  },
  computed: {
    ...mapGetters("user", { name: "name", avatar: "avatar", hasWxa: "hasWxa" }),
  },
  components: {
    LeftParagraphs,
    BasePro,
    FormTitle,
    EditParagraphs,
    Sticky,
    FixedFooter,
    Preview,
    MobileBox,
  },
  data: () => ({
    detail: roomDefault(),
    isShowDialog: false,
    newParagraphName: "",
    loading: true,
    showPreview: false,
  }),
  watch: {
    detail: {
      handler: function () {
        if (!isInitial) {
          clearTimeout(timer);
          timer = setTimeout(() => {
            this.handleSaveToDraft(true);
          }, 1000);
        }
        isInitial = false;
      },
      deep: true,
    },
  },
  created() {
    const { draftId = 0, projectId = 0 } = this.$route.query;
    Object.assign(this.detail, { draftId, projectId });

    if (projectId) {
      this.getHouseEditData(projectId);
    } else if (draftId) {
      this.getDraftData(draftId);
    } else {
      this.loading = false;
    }
  },
  methods: {
    handleShowAddDialog() {
      this.isShowDialog = true;
    },
    handleHideAddDialog() {
      this.isShowDialog = false;
      this.newParagraphName = "";
    },
    handleAddMaterial(index, file) {
      console.log(index, file);
      const [type] = file.type.split("/");
      let mediaType = "";
      if (type === "image") {
        mediaType = 1;
      } else if (type === "video") {
        mediaType = 2;
      }
      this.detail.paragraphs[index].materials.push({
        mediaType: mediaType,
        cover:
          type === "video"
            ? file.originalUrl + "?vframe/jpg/offset/1"
            : file.originalUrl,
        videoUrl: type === "video" ? file.originalUrl : "",
        content: "",
        imgInfo: file,
      });
    },
    hasParagraph(value) {
      const titles = this.detail.paragraphs.map((item) => item.title);
      return titles.includes(value);
    },
    handleAddParagraphs() {
      if(!this.newParagraphName.trim()) {
        this.$message.error("空间名称不能为空！");
        return
      }
      if (this.hasParagraph(this.newParagraphName)) {
        this.$message.error(this.newParagraphName + "已存在");
      } else {
        this.detail.paragraphs.push({
          paragraphId: guid(),
          title: this.newParagraphName,
          materials: [],
        });
        this.handleHideAddDialog();
      }
    },
    handleCoverUploadSuccess(data) {
      let json = {};
      try {
        json = JSON.parse(data);
      } catch (err) {
        json = {};
      }
      this.detail.cover = json;
    },
    removeMaterial(pIndex, index) {
      this.detail.paragraphs[pIndex]["materials"].splice(index, 1);
    },
    // addMaterial(pIndex, material) {
    //   this.detail.paragraphs[pIndex]["materials"].push(material);
    // },
    getDraftData(draftId) {
      fetchHouseDraftData(draftId).then((res) => {
        this.detail = res.data;
        this.loading = false;
      });
    },
    getHouseEditData(projectId) {
      fetchHouseEditData(projectId).then((res) => {
        this.detail = res.data;
        this.detail.draftId = 0;
        this.loading = false;
      });
    },
    handleScrollToParagraph(id) {
      const paragraph = document.getElementById(id);
      const html = document.querySelector("html");
      html.scrollTop = paragraph.offsetTop + 80;
    },
    handlePreview() {
      this.showPreview = true;
    },
    handleSaveToDraft(isAuto) {
      console.log("提交数据", JSON.stringify(this.detail));
      fetchSaveDraft(this.detail).then((res) => {
        const { draftId } = res.data;
        this.detail.draftId = draftId;
        const { draftId: _id = 0 } = this.$route.query;
        // 记录滚动位置
        this.$route.meta.y = window.pageYOffset
        if (!_id) {
          this.$router.push({
            query: {
              draftId: draftId,
            },
          });
        }
        if (!datenow || +new Date() - datenow >= 60000 || !isAuto) {
          datenow = +new Date();
          this.$message.success({
            showClose: true,
            message: isAuto ? "自动保存成功" : "保存成功",
          });
        }
      });
    },
    handlePublished() {
      const { projectId, draftId } = this.detail;
      fetchPublish({
        projectId,
        draftId,
      }).then(() => {
        this.$message.success("发布成功");
        this.$router.push("/published");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.mt28 {
  margin-top: 28px;
}
.mt50 {
  margin-top: 50px;
}
.r-container {
  margin: 40px auto 80px auto;
  width: 1100px;
  display: flex;
  justify-content: space-between;
  background: none;
  .left-bar {
    width: 150px;
    margin-right: 10px;
    background: #fff;
    position: relative;
    z-index: 2000;
    .el-scrollbar {
      height: calc(100vh);
    }
    .icon-mini-block {
      display: inline-block;
      width: 3px;
      height: 8px;
      margin-right: 5px;
      background: #333;
    }
    .el-menu-item.is-active {
      color: #fff;
      background: #488df8;
      .icon-mini-block {
        background: #fff;
      }
    }
    .el-menu-item,
    .el-submenu__title {
      height: 46px;
      line-height: 46px;
    }
  }
  .right-container {
    flex: 1;
    padding: 30px;
    background: #fff;
  }
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
  }
  .flex-right {
    display: flex;
    justify-content: flex-end;
    .publish-target {
      width: 200px;
      margin-top: 20px;
    }
  }
}
</style>
